export default function(x, y) {
  return 'translate(' + x + ',' + y + ')';
}